
	import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import SearchSVG from '@/components/SearchSVG.vue';

	@Observer
	@Component({
		components: { SearchSVG }
	})
	export default class ShoeSizeModal extends Vue {
		openModal() {
			this.$state.utils.showSearchModal = true;
		}
	}
